exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.no-pad-left[data-v-06f6fb82] {\n  padding-left: 0!important;\n}\nspan.biz-name[data-v-06f6fb82] {\n  display: inline-block;\n  width: 366px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n", "", {"version":3,"sources":["/app/src/pages/spam/SpamListing.vue"],"names":[],"mappings":";AACA;EACE,0BAA0B;CAC3B;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;CACzB","file":"SpamListing.vue","sourcesContent":["\n.no-pad-left[data-v-06f6fb82] {\n  padding-left: 0!important;\n}\nspan.biz-name[data-v-06f6fb82] {\n  display: inline-block;\n  width: 366px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06f6fb82","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/spam/SpamListing.vue
// module id = JFZp
// module chunks = 4